import { zodResolver } from '@hookform/resolvers/zod';
import { Modal, Stack } from '@mantine/core';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { Form, identitySchema } from '@/core/components';

import { MinStdAnnexSelectControl } from './MinStdAnnexSelectControl';

interface MinStdOpenModalProps {
  onSubmit: (v: DataSchema) => void;
  isSubmitting: boolean;
  onClose: () => void;
}

const schema = z.object({
  minStdAnnexNo: identitySchema,
});

type DataSchema = z.infer<typeof schema>;

export function MinStdOpenModalForm(props: MinStdOpenModalProps) {
  const { onClose, isSubmitting, onSubmit } = props;

  const { t } = useTranslation();
  const { control, handleSubmit } = useForm<DataSchema>({
    resolver: zodResolver(schema),
  });

  return (
    <Modal
      opened
      centered
      onClose={onClose}
      title={t('minStd.selectAnnex')}
    >
      <Form
        onSubmit={handleSubmit(onSubmit)}
        onCancel={onClose}
        title=""
        isSubmitting={isSubmitting}
      >
        <Stack gap="xl">
          <MinStdAnnexSelectControl
            label={t('minStd.selectAnnex')}
            name="minStdAnnexNo"
            control={control}
            isSubmitting={isSubmitting}
          />
        </Stack>
      </Form>
    </Modal>
  );
}
